import React, { useState, useEffect, useRef } from 'react';
import { Button, Chip, useTheme as useMuiTheme, useMediaQuery } from '@material-ui/core';
import { mdiContentCopy } from '@mdi/js';
import Icon from '@mdi/react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import prism from 'react-syntax-highlighter/dist/cjs/styles/prism';
import styled from 'styled-components';
import { IconSize } from '../../../../lib';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
import { SupportedLanguagesDetails } from './languages';
export { SupportedLanguages, SupportedLanguagesDetails } from './languages';
const CodeToolbar = styled.div `
    display: flex;
    justify-content: flex-end;
    align-items: center;

    > * {
        margin: 0 5px;

        &:last-child {
            margin-right: 0;
        }
    }
`;
const COPY_BUTTON_FEEDBACK_TIMEOUT = 3000;
const StyledIcon = styled(Icon) `
    color: ${(props) => props.theme.colors.text};
`;
const StyledChip = styled(Chip) `
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
`;
const CodeViewer = ({ componentValues, hideCopyIcon, onCopied = () => { }, copyIconPath }) => {
    const { body, language = 'shell' } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const [copied, setCopied] = useState(false);
    const copiedTimeout = useRef(null);
    const muiTheme = useMuiTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('xs'));
    useEffect(() => {
        return () => {
            if (copiedTimeout.current) {
                clearTimeout(copiedTimeout.current);
            }
        };
    }, []);
    const renderCopyIcon = () => {
        if (!hideCopyIcon) {
            return (React.createElement(CopyToClipboard, { text: body !== null && body !== void 0 ? body : '', onCopy: () => {
                    setCopied(true);
                    if (copiedTimeout.current)
                        clearTimeout(copiedTimeout.current);
                    copiedTimeout.current = setTimeout(() => {
                        setCopied(false);
                    }, COPY_BUTTON_FEEDBACK_TIMEOUT);
                    onCopied(body);
                }, "data-testid": "CodeViewer-CopyToClipboard" },
                React.createElement(Button, { "aria-label": "Copy Code to Clipboard", variant: "contained", startIcon: React.createElement(StyledIcon, { path: copyIconPath !== null && copyIconPath !== void 0 ? copyIconPath : mdiContentCopy, size: IconSize.Small }) }, copied ? 'Copied' : 'Copy')));
        }
        return null;
    };
    const renderCode = () => {
        const sharedHighlighterProps = {
            style: prism,
            language: language
        };
        const mobileHighlighterProps = Object.assign(Object.assign({}, sharedHighlighterProps), { wrapLongLines: true, customStyle: { fontSize: '0.8em' } });
        const standardHighlighterProps = Object.assign(Object.assign({}, sharedHighlighterProps), { showLineNumbers: true });
        const highlighterProps = isMobile ? mobileHighlighterProps : standardHighlighterProps;
        if (body) {
            return (React.createElement(React.Fragment, null,
                React.createElement(CodeToolbar, null,
                    language && SupportedLanguagesDetails[language] && (React.createElement(StyledChip, { label: SupportedLanguagesDetails[language].label })),
                    renderCopyIcon()),
                React.createElement(SyntaxHighlighter, Object.assign({}, highlighterProps), body)));
        }
        return null;
    };
    return React.createElement(ViewerErrorBoundary, null, renderCode());
};
export default CodeViewer;
//# sourceMappingURL=index.js.map